var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{on:{"click":_vm.openModal}},[_c('img',{staticClass:"ml-1 cursor-pointer",attrs:{"src":require("../../assets/images/icons/qr-code-scan-icon.svg"),"width":"30px","alt":"qr_code"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }